import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export function processBatch(batch, plantRecordMap) {
  // Filter plants in this batch that exist in plant_record_list
  const matchingPlants = batch.plants
      .filter((plant) => plantRecordMap.has(String(plant.position_id)))
      .map((plant) => {
        const plantRecord = plantRecordMap.get(String(plant.position_id));
        return {
          plant_id: plant.position_id,
          properties: plant.plant_properties,
          leaf_area_index: plantRecord?.leaf_area_index || 0,
        };
      });

  if (matchingPlants.length === 0) {
    return [];
  }

  // Calculate averages and get first color
  const avgBranchCount = matchingPlants.reduce(
      (sum, p) => sum + (p.properties?.branch_count || 0),
      0,
  ) / matchingPlants.length;
  const avgBudCount = matchingPlants.reduce(
      (sum, p) => sum + (p.properties?.bud_count || 0),
      0,
  ) / matchingPlants.length;
  const avgLargestBudDiameter = matchingPlants.reduce(
      (sum, p) => sum + (p.properties?.largest_bud_diameter || 0),
      0,
  ) / matchingPlants.length;
  const avgLeafAreaIndex = matchingPlants.reduce(
      (sum, p) => sum + (p.leaf_area_index || 0),
      0,
  ) / matchingPlants.length;
  const productColor = matchingPlants[0]?.properties?.product_color || '-';
  const plantIds = matchingPlants.map((p) => p.plant_id).join(', ');

  return [{
    batch_id: batch.batch_id,
    avg_branch_count: avgBranchCount.toFixed(1),
    avg_bud_count: avgBudCount.toFixed(0),
    avg_largest_bud_diameter: avgLargestBudDiameter.toFixed(0),
    avg_lai: avgLeafAreaIndex.toFixed(2),
    product_color: productColor,
    plant_ids: plantIds,
  }];
}

function TableBatches(props) {
  const {snapshot} = props;

  // Get plant_record_list from snapshot
  const plantRecordList = snapshot?.data?.analysis_data?.plant_record_list;
  if (!plantRecordList || plantRecordList.length === 0) {
    return null;
  }

  // Create a map of plant records by plant_id for quick lookup
  const plantRecordMap = new Map(plantRecordList.map((plant) => [String(plant.plant_id), plant]));
  // Extract batches from instance data
  const batches = snapshot.location.container.batches;

  // Filter batches: keep only those that have at least 1 plant in plant_record_list
  const filteredBatches = batches.flatMap((batch) => processBatch(batch, plantRecordMap));

  // Return nothing if no batches have matching plants
  if (filteredBatches.length === 0) {
    return null;
  }

  return (
    <div>
      <TableContainer component={Paper}>
        <Table size="small" variant="outlined" style={{borderColor: '#ddd'}}>
          <TableHead>
            <TableRow style={{backgroundColor: '#f5f5f5'}}>
              <TableCell><b>Batch ID</b></TableCell>
              <TableCell><b>Avg Branch Count</b></TableCell>
              <TableCell><b>Avg Bud Count</b></TableCell>
              <TableCell><b>Avg Largest Bud Diameter</b></TableCell>
              <TableCell><b>Avg Leaf Area Index</b></TableCell>
              <TableCell><b>Product Color</b></TableCell>
              <TableCell><b>Plant IDs</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBatches.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.batch_id}</TableCell>
                <TableCell>{row.avg_branch_count}</TableCell>
                <TableCell>{row.avg_bud_count}</TableCell>
                <TableCell>{row.avg_largest_bud_diameter}</TableCell>
                <TableCell>{row.avg_lai}</TableCell>
                <TableCell>{row.product_color}</TableCell>
                <TableCell>{row.plant_ids}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default TableBatches;
